import styles from './index.module.scss';
import EachAreaAlarmRanking from '../EachAreaAlarmRanking';
import AlarmStatistics from '../AlarmStatistics';
import AlarmType from '../AlarmType';

const AlarmArea = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <AlarmStatistics />
        <AlarmType />
      </div>
      <div className={styles.right}>
        <EachAreaAlarmRanking />
      </div>
    </div>
  );
};

export default AlarmArea;
